import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { getJob, getJobPageData, JobsGet } from '@collections/jobs';
import { managerGet } from '@collections/managers/managers.action';
import { Store } from '@ngrx/store';
import { Job } from '@shared';
import { Observable } from 'rxjs';
import { filter, first, mapTo, switchMap, tap } from 'rxjs/operators';
import { fromCreateJob, jobFormIdSelect } from './store';

@Injectable({
  providedIn: 'root',
})
export class ResolveCloneResolver {
  constructor(private store: Store<{}>) {}
  resolve(route: ActivatedRouteSnapshot): Observable<Job> {
    this.store.dispatch(fromCreateJob({ fromCreateJob: 'clone' }));

    const id = route.params.id;

    if (id) {
      this.store.dispatch(new JobsGet({ id }));
    }
    this.store.dispatch(jobFormIdSelect({ id }));

    return this.store.select(getJob(id)).pipe(
      filter((v) => !!v),
      tap(({ companyManagerId }) => {
        if (!!companyManagerId) {
          this.store.dispatch(managerGet({ id: companyManagerId }));
        }
      }),
      switchMap((job) => this.store.select(getJobPageData, { id }).pipe(first(), mapTo(job))),
      first(),
    );
  }
}
